module.exports = __webpack_public_path__ + "img/winterCougarTennis.a99910ea.png";